import { render } from "./FaqBanner.vue?vue&type=template&id=3866780f"
import script from "./FaqBanner.vue?vue&type=script&lang=js"
export * from "./FaqBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__